import {createAction} from 'redux-actions';

export const APP_SET_COMPUTING = 'APP_SET_COMPUTING';
export const APP_SET_CONFIG = 'APP_SET_CONFIG';

export const appSetComputing = createAction(APP_SET_COMPUTING);
export const appSetConfig = createAction(APP_SET_CONFIG);
